import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/primary-arrow-left.png'


const _withScopeId = n => (_pushScopeId("data-v-5beb43f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-oc-detail"
}
const _hoisted_2 = { class: "box-back" }
const _hoisted_3 = { class: "box-header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "collection-title" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "list" }
const _hoisted_8 = { class: "list-item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "list-item" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "section-title" }
const _hoisted_15 = { class: "list" }
const _hoisted_16 = { class: "list-item" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "list-item" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "list-item" }
const _hoisted_23 = { class: "label" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "list-item" }
const _hoisted_26 = { class: "label" }
const _hoisted_27 = { class: "value strong" }
const _hoisted_28 = { class: "list-item" }
const _hoisted_29 = { class: "label" }
const _hoisted_30 = { class: "value strong" }
const _hoisted_31 = {
  key: 0,
  class: "list-item"
}
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "value strong" }
const _hoisted_34 = {
  key: 1,
  class: "list-item"
}
const _hoisted_35 = { class: "label" }
const _hoisted_36 = { class: "value strong" }
const _hoisted_37 = {
  key: 1,
  class: "list-item list-item-code"
}
const _hoisted_38 = { class: "label" }
const _hoisted_39 = { class: "box-codes" }
const _hoisted_40 = { class: "index" }
const _hoisted_41 = { class: "value" }
const _hoisted_42 = {
  key: 2,
  class: "box-pagination"
}

import { useI18n } from 'vue-i18n';
  import { onMounted, ref, nextTick } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { request } from '@/utils';
  import { IUserRequest } from '@/types/user-request';
  import { USER_REQUEST_STATE_MAP, OC_REWARD_STATE } from '@/constants';
  import { Collection } from '@/stores';
  import { PDOType } from '@/types/pdo';

  interface OCUserRequestStore extends Collection {
    data: IUserRequest[];
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const store = Collection.create<OCUserRequestStore>({
    fetch(params = {}) {
      return request.get('/user_requests', { params: { ...params, participation_request_id_eq: route.params.id, type_eq: 'CollectionRequest', oc_or_pdo_records: true } });
    }
  });

  const userRequest = ref<IUserRequest>();
  async function fetchUserRequest() {
    const { data } = await request.get<IUserRequest>(`/user_requests/${route.params.id}`);
    userRequest.value = data;
  }

  const { t } = useI18n();
  onMounted(() => {
    fetchUserRequest();
    store.fetchData();
  });

  function handlePageChange(page: any) {
    store.params.page = page;
    store.fetchData();
  }

  function getItemLocationName(item: IUserRequest) {
    if (item.collection_bin?.target_type === 'OfflineCollection') {
      return item.collection_bin?.company_account.name;
    }
    if (item.collection_bin?.target_type === 'PDO') {
      return (item.collection_bin?.target as PDOType)?.facility_name;
    }
    return '';
  }

  function getItemLocationAddress(item: IUserRequest) {
    if (item.collection_bin?.target_type === 'OfflineCollection') {
      return item.collection_bin?.company_account.store_address?.street_address;
    }
    if (item.collection_bin?.target_type === 'PDO') {
      const target = item.collection_bin?.target as PDOType;
      return [target?.street_address, target?.extended_address].join('');
    }
    return '';
  }

  function getRewardType(item: IUserRequest) {
    const { is_oc_reward_points, is_oc_reward_coupon } = item;
    const pointText = t('offline_collection.oc_reward_type.points');
    const couponText = t('offline_collection.oc_reward_type.coupon');
    if (is_oc_reward_points && is_oc_reward_coupon) {
      return `${pointText} ${couponText}`;
    }
    if (is_oc_reward_points) {
      return pointText;
    }
    if (is_oc_reward_coupon) {
      return couponText;
    }
    return '/';
  }

  const router = useRouter();
  async function handleBack() {
    router.back();
    await nextTick();
    if (router.currentRoute.value.name !== 'mine.collectionHistory') {
      router.replace({ name: 'mine.collectionHistory' });
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (userRequest.value?.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "icon",
            onClick: handleBack
          }),
          _createElementVNode("span", {
            class: "text",
            onClick: handleBack
          }, _toDisplayString(_unref(t)('back')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "image",
            src: userRequest.value.target.image?.url
          }, null, 8, _hoisted_4),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(userRequest.value.target.name), 1)
        ]),
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('Application Date')), 1),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_AppTimeFormat, {
                  time: userRequest.value.created_at,
                  format: "YYYY-MM-DD"
                }, null, 8, ["time"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('Application Status')), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(USER_REQUEST_STATE_MAP)[userRequest.value.state]), 1)
            ])
          ])
        ]),
        (_unref(store).isEmpty)
          ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(store).data, (userRequestItem) => {
              return (_openBlock(), _createElementBlock("section", {
                key: userRequestItem.id,
                class: "section"
              }, [
                _createElementVNode("h3", _hoisted_14, _toDisplayString(_unref(t)('Offline Collection Information')), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('Date of Colletion')), 1),
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_AppTimeFormat, {
                        time: userRequestItem.created_at,
                        format: "YYYY-MM-DD"
                      }, null, 8, ["time"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('Location Name')), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(getItemLocationName(userRequestItem)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)('Location Address')), 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(getItemLocationAddress(userRequestItem)), 1)
                  ]),
                  (userRequestItem.is_offline_collection)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)('Rewards Type')), 1),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(getRewardType(userRequestItem)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('Rewards Status')), 1),
                          _createElementVNode("span", _hoisted_30, [
                            (userRequestItem.can_request_oc_reward)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: { name: 'offline_collections.bin.request_reward', params: { id: userRequestItem.collection_bin?.target_id, binId: userRequestItem.collection_bin?.id, userRequestId: userRequestItem.id } }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('offline_collection.request_reward')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_unref(OC_REWARD_STATE)[userRequestItem.reward_state]), 1)
                                ], 64))
                          ])
                        ]),
                        (userRequestItem.reward_state === 'approved')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (userRequestItem.is_oc_reward_coupon)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('View Rewards')), 1),
                                    _createElementVNode("span", _hoisted_33, [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'mine.coupons', query: { program_id_eq: userRequestItem.target_id } }
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('View')), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (userRequestItem.is_oc_reward_points)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(t)('Earned Points')), 1),
                                    _createElementVNode("span", _hoisted_36, [
                                      _createVNode(_component_router_link, { to: { name: 'mine.tc_point'} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(userRequestItem.reward_points), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (userRequestItem.collected_items)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('Barcode of the Collected Items')), 1),
                        _createElementVNode("div", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userRequestItem.collected_items, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "item"
                            }, [
                              _createElementVNode("span", _hoisted_40, _toDisplayString(index + 1) + ".", 1),
                              _createElementVNode("span", _hoisted_41, _toDisplayString(item.barcode), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
        (_unref(store).meta.total_pages > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createVNode(_component_AppPagination, {
                total: _unref(store).meta.total,
                "per-page": _unref(store).meta.per_page,
                page: _unref(store).meta.page,
                onChange: handlePageChange
              }, null, 8, ["total", "per-page", "page"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})